module.exports = __webpack_public_path__ + "img/main_product_women2.63a5b7ce.jpg";